import React, {useState,useEffect, setGlobal, getGlobal} from 'reactn';
import {Button, Modal, Input, message, DatePicker } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import { useFirestore } from 'reactfire';
import SingleMedicine from './components/singleMedicine';
import SingleShowMedicine from './components/singleShowMedicine';
import ManageFavourites from './components/manageFav';
import SearchMedicines from './components/searchMedicines';
import FinalReport from '../Report/FinalReport';
import {useParams} from 'react-router-dom';

const Treatment = () => {
const [medicines, setMedicines] = useState([]);
const firestore = useFirestore();
let { appointmentId } = useParams();

const { Search } = Input;

const [medicineName, setMedicineNames] = useState([]);
const [favLIst , setFavList] = useState([]);
const [investigations, setInvestigation] = useState({});
const [diseases, setDiseases] = useState([]);

const query_medicines = firestore.collection("Treatment_records");
const query_fav = firestore.collection('Favourite_Treatment');
const query = firestore.collection("Treatment");
const appointments_q = firestore.collection("appointments");

const [isModalVisible, setIsModalVisible] = useState(false);
const [showFavName, setShowFavName] = useState(false);

const [showPrint, setShowPrint] = useState(true);

const [fixPosition, setfixPosition] = useState(false);

const [favLoading, setFavLoading] = useState(false);


  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    getAllMedicinesTaken();
    getAllRecords();
    console.log('getGlobal() : ', getGlobal());
    window.addEventListener('scroll', listenToScroll)

  }, []);

  const listenToScroll = () => {
 
  const position = window.pageYOffset;

    if (position > 490) {
      setfixPosition(true);
    } else {
      setfixPosition(false);
    }
  }


  const getAllRecords = () => {
    let records = [];
    query_fav.orderBy('timestamp').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            records.push({value  : doc.data(), id: doc.id});
        });
        setFavList(records);
        setFavLoading(false);
    });
}

  const getAllMedicinesTaken = () => {
    let records = [];
    query_medicines.orderBy('timestamp').where("appointment_id", "==", getGlobal().appointmentId).get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
      console.log('this is query', doc);

          records.push({value: doc.data().medicine_info, id: doc.id});
      });
      setMedicines(records);
    }).finally(() => {
      getExaminations();
      getInvestigations();
      getAllDiseasesTaken();
    })
  }

  const recordUpdate = (index) => {
    var dummarr = [...medicineName];
    if (index !== -1) {
      dummarr.splice(index, 1);
      setMedicineNames(dummarr);
    }
    getAllMedicinesTaken();
  }

  const onSelect = (data) => {
    // setMedicineNames([...medicineName, data]);
    // setShowReset(true);
      // setState([{test_name: {test_name: data}, key: Math.random(), numbers: 1}]);
      // setLoading(true);

      console.log('ON select is')
      let records = [];
      query.where("medicine_name", "==", data).get().then((querySnapshot) => {
          let index = 0;
          querySnapshot.forEach((doc) => {
              ++ index;
              records.push({medicine: doc.data(), key: doc.id});
          });
      }).finally(() => {
        setMedicineNames([...records, ...medicineName]);
        // console.log(records);
          // setLoading(false);
      });
  };

  const manageFavoriteModal = () => {
    setIsModalVisible(true);
  }

  // const submitFav = (favListName) => {
  //   setFavLoading(true);
  //   query_fav.add({
  //     favourite_list_name: favListName,
  //     timestamp: new Date(),
  //     }).then(() => {
  //       message.success('Favorite list added successfully');
  //       getAllRecords();
  //   });
  // }

  const onDeleteFavList = () => {
    getAllRecords();
  }

  const favLIstSelected = (favListarg) => {
    let records = [];
    if (favListarg.value.Treatment_list) {
      favListarg.value.Treatment_list.map((lst)=> {
        records.push(lst.value);
      });
      console.log('THIS is RECORDs : ',records);
      setMedicineNames(records);
    }
  }

  const submitFavList = (val) => {
    console.log(val);
    query_fav.add({
      favourite_list_name: val,
      timestamp: new Date(),
      Treatment_list: medicines,
      }).then(() => {
        message.success('Favorite list added successfully');
        getAllRecords();
        setShowFavName(false);
    });
  }

  const getExaminations = () => {
      let records = [];
      firestore.collection("Examination").where("appointment_id", "==", appointmentId).get()
      .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
              records.push({data: doc.data(), id: doc.id});
          });
          setGlobal({examination_location: records.length > 0 ? records[0].data.examination_location : getGlobal().examination_location});
          setGlobal({examination_location_id: records.length > 0 ? records[0].id : null});
      });
  }

  const getInvestigations = () => {
    let records = [];
    firestore.collection("Investigation_records").where("appointment_id", "==", getGlobal().appointmentId).get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
          records.push({value: doc.data().test_info, id: doc.id, image: doc.data().test_image_url});
      });
      setInvestigation(records);
    });
  }

  const getAllDiseasesTaken = () => {
    let records = [];
    firestore.collection("Diagnosis_records").where("appointment_id", "==", getGlobal().appointmentId).get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
          records.push({value: doc.data().disease_info, id: doc.id});
      });
      setDiseases(records);
    });
  }

  const printthis = () => {
    setShowPrint(false);
    // window.focus();
    // window.print();
    // return true;
  }

  const closePrintViewReport = () => {
    setShowPrint(true);
  }

  const onChange = (date, dateString) => {
    appointments_q.doc(appointmentId).update({
      nextVisit: dateString,
  }).then(() => {
      setGlobal({next_visit_date: dateString});
      // serRedirect(true);
      // setLoader(false);
  });
  }

  return (
    <div style={{position: 'relative'}}>

    {showPrint ? <>

      <div>
        <DatePicker placeholder="Next Visit" onChange={onChange} />
      </div>
      
      <Button style={{position : 'absolute', top: '-30px', right: '0px'}} className="SaveFormButton" onClick={manageFavoriteModal} type="primary">Manage Favorites</Button>
      

      <div style={{display: 'flex'}}>
        <SearchMedicines onSelectProp = {onSelect} />
      </div>
      <div className='showFavListing'>
          <h3>Favorite Lists :</h3>
          <ul>
            {favLIst.map((singleFav) => {
              return <li key={singleFav.id} onClick={() => favLIstSelected(singleFav)}>{singleFav.value.favourite_list_name}</li>
            })}
          </ul>
      </div>
      <div className="medicines_container">
        {medicineName && (
          <div className="medicines_wrapper">
            {medicineName && medicineName.length > 0 && <h3>Taken Medicines</h3>}
            <ul className='taken_medicines'>
              {medicineName && medicineName.map((medicine, index) => {
                return <SingleMedicine key={Math.random()} medicinename={medicine} recAdded={() => recordUpdate(index)} />
              })}
              {/* {medicineName && medicineName.length > 0 && <Button>Submit All</Button>} */}
            </ul>
          </div>
        )}
        <div className='showMedicinesTaken' style={fixPosition ? {position: 'fixed', top: '0px' , right: '50px', backgroundColor: '#fff', height: 'calc(100vh - 110px)'} : {position: 'static'}}> 
          {medicines && medicines.length > 0 && <div className="showViewHeading"><h3>View current Medicines</h3> <a onClick={() => setShowFavName(true)} style={{display: 'block', textAlign: 'center', paddingBottom: '10px'}} href="#">Make this Favorite</a> <span onClick={printthis}><PrinterOutlined /></span></div>}
            {showFavName && 
              <Search
              placeholder="Add Favorite list name"
              allowClear
              enterButton="Submit"
              style={{width: '100%', margin: '0 auto', display: 'block', marginBottom: '15px'}}
              size="large"
              onSearch={(value) => submitFavList(value)}
            />
            }
            <button onClick={() => getAllMedicinesTaken()}>Refresh</button>
            {medicines && medicines.length > 0 && <ul>
              {medicines && medicines.map((te) => {
                return <SingleShowMedicine key={Math.random()} medicine={te.value} id={te.id} deletedRecord={recordUpdate} />
              })}
            </ul>}
        </div>
        </div></>
         : 
        <FinalReport appID={appointmentId} closeFinalReport={closePrintViewReport} />
        }

      

    <Modal title="Manage favourites Treatment" width='60%' footer={null} visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
    {/* <Search
      placeholder="Add Favourites list"
      allowClear
      enterButton="Submit"
      style={{width: '50%', margin: '0 auto', display: 'block'}}
      size="large"
      onSearch={(value) => submitFav(value)}
    /> */}
    
    <ManageFavourites favRecords={favLIst} refreshFavList={onDeleteFavList} />

    </Modal>

    </div>
  );
}

export default Treatment;
